import type { PortfolioReport } from '@interfaces/portfolioReport';
import { CurrencyFlag } from '@ovComponents/3-pattern/currencyFlag/currencyFlag';
import { Box } from 'hephaestus/web';
import { resolvePortfolioDisplayCurrencies } from '../../utils/presentation/portfolioCurrencyPresentation';

export type BulkRebalancePortfolioCurrencyFlagsProps = {
  report?: PortfolioReport | null;
  size?: number;
  testId?: string;
};

export const BulkRebalancePortfolioCurrencyFlags = ({
  report,
  size = 16,
  testId = 'bulk-rebalance-portfolio-currency-flags',
}: BulkRebalancePortfolioCurrencyFlagsProps) => {
  if (!report) {
    return null;
  }

  const currencies = resolvePortfolioDisplayCurrencies(report);

  if (currencies.length === 0) {
    return null;
  }

  return (
    <Box
      data-testid={testId}
      sx={{
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
        flexWrap: 'nowrap',
      }}
    >
      {currencies.map((currency) => (
        <CurrencyFlag
          key={currency}
          height={size}
          width={size}
          baseCurrency={currency}
        />
      ))}
    </Box>
  );
};
